import {createApp} from 'vue';
import DevopsDashboard from '../../../js/components/DevopsDashboard.vue';

export function initDevopsDashboard() {
  const el = document.querySelector<HTMLElement>('#devops-dashboard-app');
  if (!el) return;

  const locale = JSON.parse(el.getAttribute('data-locale') ?? '{}');

  const scopeTypeAttr = el.getAttribute('data-scope-type');
  const scopeType = scopeTypeAttr === 'org' || scopeTypeAttr === 'repo' ? scopeTypeAttr : 'global';

  const maxRangeDaysAttr = Number(el.getAttribute('data-max-range-days'));
  const maxRangeDays = Number.isFinite(maxRangeDaysAttr) && maxRangeDaysAttr > 0 ? maxRangeDaysAttr : undefined;

  const topOptionsAttr = el.getAttribute('data-top-options');
  const topOptions = topOptionsAttr ? JSON.parse(topOptionsAttr) : undefined;

  const initialFiltersAttr = el.getAttribute('data-initial-filters');
  const initialFilters = initialFiltersAttr ? JSON.parse(initialFiltersAttr) : undefined;

  // Distinct from `data-initial-filters` (which reflects whatever this particular request
  // resolved to, e.g. after applying `?top=20`): this is the admin-configured baseline used for
  // the reset button and the "filters active" indicator. Always rendered by the backend
  // alongside `data-initial-filters`; `resolveDefaultRawFilters` in `DevopsDashboardFilterModel.ts`
  // still falls back to `initialFilters` defensively if it is ever missing.
  const defaultFiltersAttr = el.getAttribute('data-default-filters');
  const defaultFilters = defaultFiltersAttr ? JSON.parse(defaultFiltersAttr) : undefined;

  createApp(DevopsDashboard, {
    title: el.getAttribute('data-title') ?? 'DevOps Dashboard',
    dataUrl: el.getAttribute('data-data-url') ?? '',
    exportUrl: el.getAttribute('data-export-url') ?? '',
    defaultRange: el.getAttribute('data-default-range') ?? '30d',
    logoUrl: el.getAttribute('data-logo-url') ?? '/img/logo.svg',
    homeUrl: el.getAttribute('data-home-url') ?? '/',
    homeLabel: el.getAttribute('data-home-label') ?? '',
    locale,
    scopeType,
    filtersUrl: el.getAttribute('data-filters-url') ?? '',
    maxRangeDays,
    topOptions,
    initialFilters,
    defaultFilters,
  }).mount(el);
}
